import { API_BASE_URL } from '../../utils/constants';

/**
 * Verify whether the currently authenticated user has admin privileges.
 * Calls the backend GET /api/admin/verify endpoint which is protected by
 * adminAuth middleware — only valid admin tokens will receive a 200 response.
 *
 * @param {string} token - Firebase ID token
 * @returns {Promise<boolean>} true if the user is an admin, false otherwise
 */
export const verifyAdmin = async (token) => {
  if (!token) return false;
  try {
    const res = await fetch(`${API_BASE_URL}/admin/verify`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
    return res.ok;
  } catch (error) {
    console.error('[adminService] Admin verification failed:', error);
    return false;
  }
};
